











































































import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { WorkerAnonModule } from '@/store/modules/workerAnon';
import { AppModule } from '@/store/modules/app';
import WorkerOfferAcceptanceAcceptDecline from '@/components/AnonWorkers/WorkerOfferAcceptanceAcceptDecline.vue';
import AnonJobWorkerOfferDto from '@/models/AnonJobWorkers/AnonJobWorkerOfferDto';

@Component({
  name: 'JobOfferAcceptance',
  components: { WorkerOfferAcceptanceAcceptDecline }
})
export default class JobOfferAcceptance extends GiganautVue {

    get offerAcceptance(): AnonJobWorkerOfferDto {
        return WorkerAnonModule.offerAcceptance;
    }

    get loading() {
        return WorkerAnonModule.loading;
    }

    get agency() {
        return AppModule.currentAgencyContext;
    }

    get isAcceptanceSubmitted() {
        return WorkerAnonModule.isJobOfferAcceptanceSubmitted;
    }
}
